import View from '@shared/components/layout-default/layout-default-router-view';

export const call_tracking = [
  {
    path: 'call-tracking',
    component: View,
    meta: {
      permissions: ['service_calltracking_is_allowed']
    },
    children: [
      {
        path: '',
        name: 'call-tracking.index',
        redirect: {
          name: 'call-tracking.number.index'
        }
      },

      {
        path: 'numbers',
        component: View,
        children: [
          {
            path: '',
            name: 'call-tracking.number.index',
            component: () =>
              import(
                /* webpackChunkName: 'call-tracking' */
                '@call-tracking/pages/numbers-list-page'
              ),
            meta: {
              title: {
                code: 'call-tracking.breadcrumb.number.index'
              }
            }
          }
        ]
      },

      {
        path: 'stats',
        component: View,
        children: [
          {
            path: '',
            name: 'call-tracking.stats.index',
            component: () =>
              import(
                /* webpackChunkName: 'call-tracking' */
                '@call-tracking/pages/tracking-stats-page'
              ),
            meta: {
              title: {
                code: 'shared.breadcrumb.stats.title'
              }
            }
          }
        ]
      },

      {
        path: 'integration',
        name: 'call-tracking.integration.index',
        component: () =>
          import(
            /* webpackChunkName: 'call-tracking' */
            '@call-tracking/pages/integration-page'
          ),
        meta: {
          title: {
            code: 'call-tracking.breadcrumb.integration.index'
          }
        }
      }
    ]
  }
];
